/* DIAMONT Theme JS — Konfigurator, Cart API, Drawer */
(function () {
  'use strict';

  var fmt = function (cents) {
    return (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  };

  /* ---------- Cart Drawer ---------- */
  var drawer = document.getElementById('CartDrawer');
  var overlay = document.getElementById('DrawerOverlay');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('open');
    overlay && overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('open');
    overlay && overlay.classList.remove('open');
    document.body.style.overflow = '';
  }
  window.diamontOpenCart = openDrawer;

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); refreshCart().then(openDrawer); }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeDrawer(); }
  });
  overlay && overlay.addEventListener('click', closeDrawer);

  function refreshCart() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; })
      .catch(function () {});
  }

  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    var list = document.getElementById('CartDrawerItems');
    var totalEl = document.getElementById('CartDrawerTotal');
    if (totalEl) totalEl.textContent = fmt(cart.total_price);
    var discEl = document.getElementById('CartDrawerDiscount');
    if (discEl) {
      var apps = cart.cart_level_discount_applications || [];
      if (cart.total_discount > 0) {
        var dtitle = apps.length && apps[0].title ? apps[0].title : 'Rabatt';
        var lbl = discEl.querySelector('[data-disc-label]');
        var amt = discEl.querySelector('[data-disc-amount]');
        if (lbl) lbl.textContent = 'Rabatt · ' + dtitle;
        if (amt) amt.textContent = '−' + fmt(cart.total_discount);
        discEl.style.display = 'flex';
      } else {
        discEl.style.display = 'none';
      }
    }
    if (!list) return;
    if (cart.items.length === 0) {
      list.innerHTML = '<p class="cd-empty">Ihr Warenkorb ist leer.</p>';
      return;
    }
    list.innerHTML = cart.items.map(function (item, i) {
      var variantLine = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      return '<div class="cd-item">' +
        '<span class="cd-img">' + (item.image ? '<img src="' + item.image + '&width=128" alt="">' : '') + '</span>' +
        '<span class="cd-info"><b>' + item.product_title + '</b>' +
        (variantLine ? '<span class="cd-variant">' + variantLine + '</span>' : '') +
        '<span class="cd-qty">' +
        '<button type="button" data-qty-change data-line="' + (i + 1) + '" data-qty="' + (item.quantity - 1) + '">−</button>' +
        '<span>' + item.quantity + '</span>' +
        '<button type="button" data-qty-change data-line="' + (i + 1) + '" data-qty="' + (item.quantity + 1) + '">+</button>' +
        '</span></span>' +
        '<span class="cd-price">' + fmt(item.final_line_price) + '</span>' +
        '</div>';
    }).join('');

    var upsell = document.getElementById('CartDrawerUpsell');
    if (upsell) {
      var nkId = parseInt(upsell.getAttribute('data-necklace-variant'), 10);
      var hasNk = cart.items.some(function (it) { return it.variant_id === nkId; });
      upsell.style.display = (nkId && !hasNk && cart.items.length) ? 'block' : 'none';
      var cuveeHandle = upsell.getAttribute('data-cuvee-handle');
      var nkPrice = parseInt(upsell.getAttribute('data-nk-price'), 10) || 0;
      var bottles = 0;
      cart.items.forEach(function (it) { if (it.handle === cuveeHandle) bottles += it.quantity; });
      var tagEl = upsell.querySelector('[data-addon-tag]');
      var titleEl = upsell.querySelector('[data-addon-title]');
      var subEl = upsell.querySelector('[data-addon-sub]');
      var btnEl = upsell.querySelector('[data-addon-btn]');
      var barWrap = upsell.querySelector('[data-addon-progress]');
      var bar = upsell.querySelector('[data-addon-bar]');
      if (bottles >= 2) {
        upsell.classList.add('nk-addon--free');
        if (tagEl) tagEl.textContent = '🎁 Geschenk freigeschaltet';
        if (titleEl) titleEl.textContent = 'DIAMONT-Halskette GRATIS dazu';
        if (subEl) subEl.innerHTML = '<s>' + fmt(nkPrice) + '</s><b style="color:#7A1F2B">0,00 &euro;</b> — jetzt kostenlos sichern.';
        if (btnEl) btnEl.textContent = 'Kostenlos hinzufügen';
        if (barWrap) barWrap.style.display = 'none';
      } else {
        upsell.classList.remove('nk-addon--free');
        var remaining = 2 - bottles;
        if (tagEl) tagEl.textContent = 'Fast geschafft';
        if (titleEl) titleEl.innerHTML = 'Halskette (im Wert von ' + fmt(nkPrice) + ') <b style="color:#7A1F2B">gratis</b> sichern';
        if (subEl) subEl.innerHTML = 'Noch <b>' + remaining + ' Flasche' + (remaining === 1 ? '' : 'n') + '</b> hinzufügen.';
        if (btnEl) btnEl.textContent = (remaining === 1 ? 'Flasche' : remaining + ' Flaschen') + ' hinzufügen';
        if (barWrap) { barWrap.style.display = 'block'; if (bar) bar.style.width = Math.min(100, (bottles / 2) * 100) + '%'; }
      }
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: parseInt(btn.getAttribute('data-line'), 10), quantity: parseInt(btn.getAttribute('data-qty'), 10) })
    }).then(function (r) { return r.json(); }).then(renderCart);
  });

  function addItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return refreshCart();
    }).then(openDrawer);
  }
  window.diamontAddItems = addItems;

  document.addEventListener('click', function (e) {
    var up = e.target.closest('[data-add-upsell]');
    if (!up) return;
    addItems([{ id: parseInt(up.getAttribute('data-add-upsell'), 10), quantity: 1 }]);
  });

  /* Halskette-Upsell: fehlende Flasche(n) + Halskette in EINEM Klick */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-addon-btn]');
    if (!btn) return;
    var upsell = document.getElementById('CartDrawerUpsell');
    if (!upsell) return;
    var nkId = parseInt(upsell.getAttribute('data-necklace-variant'), 10);
    var cuveeHandle = upsell.getAttribute('data-cuvee-handle');
    btn.disabled = true;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var bottles = 0, cuveeVariantId = null;
      cart.items.forEach(function (it) {
        if (it.handle === cuveeHandle) { bottles += it.quantity; if (!cuveeVariantId) cuveeVariantId = it.variant_id; }
      });
      var items = [];
      if (bottles < 2 && cuveeVariantId) items.push({ id: cuveeVariantId, quantity: 2 - bottles });
      if (nkId) items.push({ id: nkId, quantity: 1 });
      return addItems(items);
    }).then(function () { btn.disabled = false; }).catch(function () { btn.disabled = false; });
  });

  /* ---------- Konfigurator ---------- */
  var cfg = document.querySelector('[data-configurator]');
  if (cfg) {
    var state = {
      variantId: null,
      price: 0,
      necklace: false,
      necklaceId: parseInt(cfg.getAttribute('data-necklace-variant'), 10) || null,
      necklacePrice: parseInt(cfg.getAttribute('data-necklace-price'), 10) || 0
    };
    window.__dmState = state;

    var cards = cfg.querySelectorAll('[data-edition-card]');
    var nkOpts = cfg.querySelectorAll('[data-necklace-opt]');
    var sumTitle = cfg.querySelector('[data-sum-title]');
    var sumList = cfg.querySelector('[data-sum-list]');
    var sumTotal = cfg.querySelector('[data-sum-total]');
    var buyBtn = cfg.querySelector('[data-buy-btn]');
    var stage = document.querySelector('[data-stage]');

    function renderCfg() {
      var active = cfg.querySelector('[data-edition-card].selected');
      if (!active) return;
      var total = state.price + (state.necklace ? state.necklacePrice : 0);
      var title = active.getAttribute('data-title');
      var lines = (active.getAttribute('data-lines') || '').split('|').filter(Boolean);
      if (nkOpts.length) lines.push(state.necklace ? 'mit DIAMONT-Halskette' : 'ohne DIAMONT-Halskette');
      if (sumTitle) sumTitle.textContent = title;
      if (sumList) sumList.innerHTML = lines.map(function (l) { return '<li>' + l + '</li>'; }).join('');
      if (sumTotal) sumTotal.textContent = fmt(total);
      if (buyBtn) buyBtn.textContent = 'In den Warenkorb — ' + fmt(total);

      if (stage) {
        var img = active.getAttribute('data-image');
        var stageImg = stage.querySelector('[data-stage-img]');
        if (img && stageImg) stageImg.src = img;
        stage.classList.toggle('with-necklace', state.necklace);
        stage.classList.toggle('signature', active.getAttribute('data-signature') === 'true');
      }

      var mbT = document.getElementById('mbTitle');
      var mbP = document.getElementById('mbPrice');
      if (mbT) mbT.textContent = title.replace('DIAMONT ', '') + (state.necklace ? ' + Halskette' : '');
      if (mbP) mbP.textContent = fmt(total);
    }

    function selectCard(card) {
      cards.forEach(function (c) { c.classList.remove('selected'); });
      card.classList.add('selected');
      state.variantId = parseInt(card.getAttribute('data-variant-id'), 10);
      state.price = parseInt(card.getAttribute('data-price'), 10);
      renderCfg();
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () { selectCard(card); });
    });

    nkOpts.forEach(function (opt) {
      opt.addEventListener('click', function () {
        nkOpts.forEach(function (o) { o.classList.remove('selected'); });
        opt.classList.add('selected');
        state.necklace = opt.getAttribute('data-necklace-opt') === 'true';
        renderCfg();
      });
    });

    function doBuy(btn) {
      if (!state.variantId) return;
      var items = [{ id: state.variantId, quantity: 1 }];
      if (state.necklace && state.necklaceId) items.push({ id: state.necklaceId, quantity: 1 });
      if (btn) btn.disabled = true;
      addItems(items).then(function () { if (btn) btn.disabled = false; }).catch(function () { if (btn) btn.disabled = false; });
    }

    if (buyBtn) {
      buyBtn.addEventListener('click', function () { doBuy(buyBtn); });
    }

    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-select-edition]');
      if (t) {
        var idx = t.getAttribute('data-select-edition');
        var card = cfg.querySelector('[data-edition-card][data-index="' + idx + '"]');
        if (card) selectCard(card);
      }
      var n = e.target.closest('[data-activate-necklace]');
      if (n) {
        var yes = cfg.querySelector('[data-necklace-opt="true"]');
        if (yes) yes.click();
        cfg.scrollIntoView({ behavior: 'smooth' });
      }
      var b = e.target.closest('[data-buy-edition]');
      if (b) {
        var bidx = b.getAttribute('data-buy-edition');
        var bcard = cfg.querySelector('[data-edition-card][data-index="' + bidx + '"]');
        if (bcard) { selectCard(bcard); doBuy(b); }
      }
    });

    var first = cfg.querySelector('[data-edition-card].selected') || cards[0];
    if (first) selectCard(first);

    var mobileBar = document.getElementById('mobileBar');
    if (mobileBar) { mobileBar.classList.add('show'); }
  }

  /* Untere Kaufleiste "Jetzt bestellen": ausgewählte Edition, sonst Classic */
  document.addEventListener('click', function (e) {
    var mb = e.target.closest('[data-mobile-buy]');
    if (!mb) return;
    var bar = document.getElementById('mobileBar');
    var classicId = bar ? parseInt(bar.getAttribute('data-classic-variant'), 10) : 0;
    var st = window.__dmState || {};
    var vid = st.variantId || classicId;
    if (!vid) return;
    var items = [{ id: vid, quantity: 1 }];
    if (st.necklace && st.necklaceId) items.push({ id: st.necklaceId, quantity: 1 });
    mb.disabled = true;
    window.diamontAddItems(items).then(function () { mb.disabled = false; }).catch(function () { mb.disabled = false; });
  });

  /* ---------- Produktseite: einfacher Kauf ---------- */
  document.querySelectorAll('[data-pdp-add]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = parseInt(btn.getAttribute('data-pdp-add'), 10);
      btn.disabled = true;
      addItems([{ id: id, quantity: 1 }]).then(function () { btn.disabled = false; }).catch(function () { btn.disabled = false; });
    });
  });

  /* ---------- FAQ ---------- */
  document.querySelectorAll('.faq-q').forEach(function (q) {
    q.addEventListener('click', function () {
      var item = q.parentElement;
      var a = item.querySelector('.faq-a');
      var open = item.classList.toggle('open');
      a.style.maxHeight = open ? a.scrollHeight + 'px' : '0';
    });
  });

  /* ---------- Mobiles Menü ---------- */
  var burger = document.getElementById('burgerBtn');
  var mm = document.getElementById('mobileMenu');
  if (burger && mm) {
    burger.addEventListener('click', function () { mm.classList.toggle('open'); });
    mm.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { mm.classList.remove('open'); });
    });
  }

  refreshCart();
})();

/* ---------- DIAMONT: kleiner Abstand Edition-Auswahl ---------- */
(function () {
  var st = document.createElement('style');
  st.textContent = '.step-label{margin-bottom:22px}.editions{margin-top:6px}';
  (document.head || document.documentElement).appendChild(st);
})();
